var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.summaryLoading,
                      expression: "summaryLoading",
                    },
                  ],
                  staticClass: "statement-summary-cards",
                },
                [
                  _c("div", { staticClass: "statement-summary-card" }, [
                    _c("div", { staticClass: "summary-amount" }, [
                      _vm._v(
                        "￥" +
                          _vm._s(
                            _vm.formatAmount(_vm.statementSummary.orderAmount)
                          )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "summary-label" }, [
                      _vm._v("订单金额"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "statement-summary-card" }, [
                    _c("div", { staticClass: "summary-amount" }, [
                      _vm._v(
                        "￥" +
                          _vm._s(
                            _vm.formatAmount(
                              _vm.statementSummary.settlementAmount
                            )
                          )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "summary-label" }, [
                      _vm._v("成交结算额"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "statement-summary-card" }, [
                    _c("div", { staticClass: "summary-amount" }, [
                      _vm._v(
                        "￥" +
                          _vm._s(
                            _vm.formatAmount(
                              _vm.statementSummary.actualSettlementAmount
                            )
                          )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "summary-label" }, [
                      _vm._v("实际结算金额"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "statement-summary-card" }, [
                    _c("div", { staticClass: "summary-amount" }, [
                      _vm._v(
                        "￥" +
                          _vm._s(
                            _vm.formatAmount(
                              _vm.statementSummary.settledPriceDifference
                            )
                          )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "summary-label" }, [
                      _vm._v("已结算售后价差"),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  staticClass: "search-form",
                  attrs: { inline: "", size: "small", "label-width": "90px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "对账单号：" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请输入", clearable: "" },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handerSearch($event)
                            },
                          },
                          model: {
                            value: _vm.listPram.statementNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "statementNo", $$v)
                            },
                            expression: "listPram.statementNo",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单号：" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请输入", clearable: "" },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handerSearch($event)
                            },
                          },
                          model: {
                            value: _vm.listPram.orderNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "orderNo", $$v)
                            },
                            expression: "listPram.orderNo",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商家类型：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请选择", clearable: "" },
                          on: { change: _vm.onMerchantTypeChange },
                          model: {
                            value: _vm.listPram.merchantType,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "merchantType", $$v)
                            },
                            expression: "listPram.merchantType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "卡券供应商", value: 1 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "实物供应商", value: 2 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "家政供应商", value: 3 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "核销供应商", value: 4 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择商家：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请输入搜索商家",
                            clearable: "",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            "remote-method": _vm.handleMerchantSearch,
                            loading: _vm.merchantLoading,
                          },
                          on: { change: _vm.handerSearch },
                          model: {
                            value: _vm.listPram.merchantId,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "merchantId", $$v)
                            },
                            expression: "listPram.merchantId",
                          },
                        },
                        _vm._l(_vm.merchantOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.supplierName, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否损失：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请选择", clearable: "" },
                          on: { change: _vm.handerSearch },
                          model: {
                            value: _vm.listPram.hasLoss,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "hasLoss", $$v)
                            },
                            expression: "listPram.hasLoss",
                          },
                        },
                        [
                          _c("el-option", { attrs: { label: "是", value: 1 } }),
                          _vm._v(" "),
                          _c("el-option", { attrs: { label: "否", value: 0 } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "对账状态：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请选择", clearable: "" },
                          on: { change: _vm.handerSearch },
                          model: {
                            value: _vm.listPram.reconciliationStatus,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.listPram,
                                "reconciliationStatus",
                                $$v
                              )
                            },
                            expression: "listPram.reconciliationStatus",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "未核对", value: 0 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "已核对", value: 1 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "已驳回", value: 2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "打款状态：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请选择", clearable: "" },
                          on: { change: _vm.handerSearch },
                          model: {
                            value: _vm.listPram.paymentStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "paymentStatus", $$v)
                            },
                            expression: "listPram.paymentStatus",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "未打款", value: 0 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "部分打款", value: 1 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "已打款", value: 2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "打款主体：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请选择",
                            clearable: "",
                            filterable: "",
                            loading: _vm.companyLoading,
                          },
                          on: { change: _vm.handerSearch },
                          model: {
                            value: _vm.listPram.companyId,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "companyId", $$v)
                            },
                            expression: "listPram.companyId",
                          },
                        },
                        _vm._l(_vm.companyOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.companyName, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "打款时间：" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "payment-time-picker",
                        attrs: {
                          type: "datetimerange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "default-time": ["00:00:00", "23:59:59"],
                          "range-separator": "至",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          clearable: "",
                        },
                        on: { change: _vm.handerSearch },
                        model: {
                          value: _vm.paymentTimeRange,
                          callback: function ($$v) {
                            _vm.paymentTimeRange = $$v
                          },
                          expression: "paymentTimeRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "生成状态：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请选择", clearable: "" },
                          on: { change: _vm.handerSearch },
                          model: {
                            value: _vm.listPram.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "status", $$v)
                            },
                            expression: "listPram.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "已生成", value: 0 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "生成中", value: 1 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "生成失败", value: 2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "创建人：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "搜索创建人",
                            clearable: "",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            "remote-method": _vm.handleCreatorSearch,
                            loading: _vm.creatorLoading,
                          },
                          on: {
                            focus: _vm.handleCreatorFocus,
                            change: _vm.handerSearch,
                          },
                          model: {
                            value: _vm.listPram.creatorId,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "creatorId", $$v)
                            },
                            expression: "listPram.creatorId",
                          },
                        },
                        _vm._l(_vm.creatorOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.realName, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-toolbar" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handerSearch },
                },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleReset } },
                [_vm._v("重置")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:merchant:statement:generate"],
                      expression: "['admin:merchant:statement:generate']",
                    },
                  ],
                  staticClass: "business-action-first",
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handleGenerate },
                },
                [_vm._v("生成对账单")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:merchant:statement:unreconciled"],
                      expression: "['admin:merchant:statement:unreconciled']",
                    },
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.goUnreconciled },
                },
                [_vm._v("待对账记录")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:merchant:statement:export"],
                      expression: "['admin:merchant:statement:export']",
                    },
                  ],
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.exportLoading,
                  },
                  on: { click: _vm.handleExport },
                },
                [_vm._v("导出对账单")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:merchant:statement:export"],
                      expression: "['admin:merchant:statement:export']",
                    },
                  ],
                  attrs: { size: "small" },
                  on: { click: _vm.openStatementListExportRecords },
                },
                [_vm._v("导出记录")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                "row-key": "id",
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "statementNo",
                  label: "对账单号",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "merchantName",
                  label: "商家名称",
                  "min-width": "160",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "merchantType",
                  label: "商家类型",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.merchantTypeText(scope.row.merchantType))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "账单周期", "min-width": "220" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.periodDesc))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "生成时间",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderCount",
                  label: "订单数量",
                  "min-width": "100",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderAmount",
                  label: "订单成交金额",
                  "min-width": "130",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "amount-cell" }, [
                          _c("span", { staticClass: "amount" }, [
                            _vm._v(
                              "￥" +
                                _vm._s(_vm.formatAmount(scope.row.orderAmount))
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.hasAmount(scope.row.freightAmount)
                            ? _c("div", { staticClass: "amount-extra" }, [
                                _vm._v(
                                  "含运费：￥" +
                                    _vm._s(
                                      _vm.formatAmount(scope.row.freightAmount)
                                    )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasAmount(scope.row.packingFeeAmount)
                            ? _c("div", { staticClass: "amount-extra" }, [
                                _vm._v(
                                  "打包费：￥" +
                                    _vm._s(
                                      _vm.formatAmount(
                                        scope.row.packingFeeAmount
                                      )
                                    )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "settlementAmount",
                  label: "成交结算金额",
                  "min-width": "130",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "amount-cell" }, [
                          _c("span", { staticClass: "amount" }, [
                            _vm._v(
                              "￥" +
                                _vm._s(
                                  _vm.formatAmount(scope.row.settlementAmount)
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.hasAmount(scope.row.freightAmount)
                            ? _c("div", { staticClass: "amount-extra" }, [
                                _vm._v(
                                  "含运费：￥" +
                                    _vm._s(
                                      _vm.formatAmount(scope.row.freightAmount)
                                    )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasAmount(scope.row.packingFeeAmount)
                            ? _c("div", { staticClass: "amount-extra" }, [
                                _vm._v(
                                  "打包费：￥" +
                                    _vm._s(
                                      _vm.formatAmount(
                                        scope.row.packingFeeAmount
                                      )
                                    )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "actualAmount",
                    label: "实际结算金额",
                    "min-width": "130",
                    align: "right",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "amount-cell" }, [
                            _c("span", { staticClass: "amount actual" }, [
                              _vm._v(
                                "￥" +
                                  _vm._s(
                                    _vm.formatActualSettlementAmount(scope.row)
                                  )
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.hasAmount(
                              scope.row.actualSettlementFreightAmount
                            )
                              ? _c("div", { staticClass: "amount-extra" }, [
                                  _vm._v(
                                    "含运费：￥" +
                                      _vm._s(
                                        _vm.formatAmount(
                                          scope.row
                                            .actualSettlementFreightAmount
                                        )
                                      )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasAmount(
                              scope.row.actualSettlementPackingFeeAmount
                            )
                              ? _c("div", { staticClass: "amount-extra" }, [
                                  _vm._v(
                                    "打包费：￥" +
                                      _vm._s(
                                        _vm.formatAmount(
                                          scope.row
                                            .actualSettlementPackingFeeAmount
                                        )
                                      )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "amount-header" }, [
                      _vm._v("实际结算金额(元)"),
                    ]),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "settledPriceDifference",
                  label: "已结算售后价差",
                  "min-width": "130",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "amount" }, [
                          _vm._v(
                            "￥" +
                              _vm._s(
                                _vm.formatAmount(
                                  scope.row.settledPriceDifference
                                )
                              )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "paymentAmount",
                  label: "打款金额",
                  "min-width": "130",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "amount" }, [
                          _vm._v(
                            "￥" +
                              _vm._s(_vm.formatAmount(scope.row.paymentAmount))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.statusTagType(scope.row.status),
                              size: "small",
                            },
                          },
                          [_vm._v(_vm._s(_vm.statusText(scope.row.status)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "reconciliationStatus",
                  label: "对账状态",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "reconciliation-status-cell" },
                          [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.reconciliationStatusTagType(
                                    scope.row.reconciliationStatus
                                  ),
                                  size: "small",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.reconciliationStatusText(
                                      scope.row.reconciliationStatus
                                    )
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            scope.row.reconciliationStatus === 2 &&
                            scope.row.rejectReason
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "reject-reason-text",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.showRemarkPopover(
                                          $event,
                                          scope.row.rejectReason,
                                          "驳回原因"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-chat-line-square remark-icon",
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.formatRejectReason(
                                            scope.row.rejectReason
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "paymentStatus",
                  label: "打款状态",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.paymentStatusTagType(
                                scope.row.paymentStatus
                              ),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.paymentStatusText(scope.row.paymentStatus)
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "companyName",
                  label: "打款主体",
                  "min-width": "130",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "creatorName",
                  label: "创建人",
                  "min-width": "100",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "reconciliationRemark",
                  label: "对账备注",
                  "min-width": "240",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.reconciliationRemark
                          ? _c(
                              "div",
                              {
                                staticClass: "remark-cell",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.showRemarkPopover(
                                      $event,
                                      scope.row.reconciliationRemark,
                                      "对账备注"
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-chat-line-square remark-icon",
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "remark-text" }, [
                                  _vm._v(
                                    _vm._s(scope.row.reconciliationRemark)
                                  ),
                                ]),
                              ]
                            )
                          : _c("span", { staticClass: "remark-empty" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "financialRemark",
                  label: "财务备注",
                  "min-width": "240",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.financialRemark
                          ? _c(
                              "div",
                              {
                                staticClass: "remark-cell",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.showRemarkPopover(
                                      $event,
                                      scope.row.financialRemark,
                                      "财务备注"
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-chat-line-square remark-icon",
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "remark-text" }, [
                                  _vm._v(_vm._s(scope.row.financialRemark)),
                                ]),
                              ]
                            )
                          : _c("span", { staticClass: "remark-empty" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "340", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status !== 1 &&
                        _vm.checkPermi(["admin:merchant:statement:detail"])
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:merchant:statement:detail"],
                                    expression:
                                      "['admin:merchant:statement:detail']",
                                  },
                                ],
                                key: "statementDetail",
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetail(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              详情\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 0 &&
                        scope.row.reconciliationStatus === 1 &&
                        _vm.checkPermi(["admin:merchant:statement:edit"])
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:merchant:statement:edit"],
                                    expression:
                                      "['admin:merchant:statement:edit']",
                                  },
                                ],
                                key: "statementEdit",
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              编辑\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 0 &&
                        _vm.checkPermi(["admin:merchant:statement:order:list"])
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:merchant:statement:order:list",
                                    ],
                                    expression:
                                      "['admin:merchant:statement:order:list']",
                                  },
                                ],
                                key: "statementOrderList",
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleStatementDetail(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              账单明细\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 0 &&
                        _vm.checkPermi(["admin:merchant:statement:export"])
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:merchant:statement:export"],
                                    expression:
                                      "['admin:merchant:statement:export']",
                                  },
                                ],
                                key: "statementExport",
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDownload(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              下载对账单\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 0 &&
                        scope.row.reconciliationStatus === 1 &&
                        _vm.checkPermi([
                          "admin:merchant:statement:payment:list",
                        ])
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:merchant:statement:payment:list",
                                    ],
                                    expression:
                                      "['admin:merchant:statement:payment:list']",
                                  },
                                ],
                                key: "statementPayment",
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handlePayment(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              打款明细\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 0 &&
                        _vm.checkPermi([
                          "admin:merchant:statement:reconciliation:remark",
                        ])
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:merchant:statement:reconciliation:remark",
                                    ],
                                    expression:
                                      "['admin:merchant:statement:reconciliation:remark']",
                                  },
                                ],
                                key: "reconciliationRemark",
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleRemark(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              对账备注\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 0 &&
                        _vm.checkPermi([
                          "admin:merchant:statement:financial:remark",
                        ])
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:merchant:statement:financial:remark",
                                    ],
                                    expression:
                                      "['admin:merchant:statement:financial:remark']",
                                  },
                                ],
                                key: "financialRemark",
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleFinancialRemark(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              财务备注\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 0 &&
                        _vm.checkPermi([
                          "admin:merchant:statement:payment:detail",
                        ])
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:merchant:statement:payment:detail",
                                    ],
                                    expression:
                                      "['admin:merchant:statement:payment:detail']",
                                  },
                                ],
                                key: "paymentDetail",
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handlePaymentDetail(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              收款详情\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 0 &&
                        scope.row.reconciliationStatus === 1 &&
                        scope.row.paymentStatus === 0 &&
                        _vm.checkPermi(["admin:merchant:statement:reject"])
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:merchant:statement:reject"],
                                    expression:
                                      "['admin:merchant:statement:reject']",
                                  },
                                ],
                                key: "statementReject",
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleReject(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              驳回\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 0 &&
                        (scope.row.reconciliationStatus === 0 ||
                          scope.row.reconciliationStatus === 2) &&
                        scope.row.paymentStatus === 0 &&
                        _vm.checkPermi(["admin:merchant:statement:update"])
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:merchant:statement:update"],
                                    expression:
                                      "['admin:merchant:statement:update']",
                                  },
                                ],
                                key: "statementUpdate",
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleUpdate(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              更新对账单\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 0 &&
                        (scope.row.reconciliationStatus === 0 ||
                          scope.row.reconciliationStatus === 2) &&
                        scope.row.paymentStatus === 0 &&
                        _vm.checkPermi(["admin:merchant:statement:confirm"])
                          ? [
                              _c("el-divider", {
                                key: "statementConfirmDivider",
                                attrs: { direction: "vertical" },
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: [
                                        "admin:merchant:statement:confirm",
                                      ],
                                      expression:
                                        "['admin:merchant:statement:confirm']",
                                    },
                                  ],
                                  key: "statementConfirm",
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleConfirm(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                确认对账单\n              "
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 0 &&
                        (scope.row.reconciliationStatus === 0 ||
                          scope.row.reconciliationStatus === 2) &&
                        (scope.row.paymentStatus === 0 ||
                          scope.row.paymentStatus === 2) &&
                        _vm.checkPermi(["admin:merchant:statement:delete"])
                          ? [
                              _c("el-divider", {
                                key: "statementDeleteDivider",
                                attrs: { direction: "vertical" },
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: [
                                        "admin:merchant:statement:delete",
                                      ],
                                      expression:
                                        "['admin:merchant:statement:delete']",
                                    },
                                  ],
                                  key: "statementDelete",
                                  staticStyle: { color: "#f56c6c" },
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDelete(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                删除\n              "
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 2 &&
                        scope.row.reconciliationStatus === 0 &&
                        scope.row.paymentStatus === 0 &&
                        _vm.checkPermi(["admin:merchant:statement:regenerate"])
                          ? [
                              _c("el-divider", {
                                key: "statementRegenerateDivider",
                                attrs: { direction: "vertical" },
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: [
                                        "admin:merchant:statement:regenerate",
                                      ],
                                      expression:
                                        "['admin:merchant:statement:regenerate']",
                                    },
                                  ],
                                  key: "statementRegenerate",
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleRegenerate(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                重新生成\n              "
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": [10, 20, 30, 50],
              "page-size": _vm.listPram.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("GenerateDialog", {
        ref: "generateDialog",
        on: { refresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c("StatementDetailDialog", { ref: "statementDetailDialog" }),
      _vm._v(" "),
      _c("ReconciliationRemarkDialog", {
        ref: "reconciliationRemarkDialog",
        on: { refresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c("ConfirmStatementDialog", {
        ref: "confirmStatementDialog",
        on: { refresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c("FinancialRemarkDialog", {
        ref: "financialRemarkDialog",
        on: { refresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c("DownloadRecordDialog", { ref: "downloadDialog" }),
      _vm._v(" "),
      _c("StatementListExportTaskDialog", {
        ref: "statementListExportTaskDialog",
        on: { "open-records": _vm.openStatementListExportRecords },
      }),
      _vm._v(" "),
      _c("StatementListExportRecordDialog", {
        ref: "statementListExportRecordDialog",
      }),
      _vm._v(" "),
      _c("PaymentDetailDialog", {
        ref: "paymentDetailDialog",
        on: { refresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c("StatementOrderDialog", {
        ref: "statementOrderDialog",
        on: { refresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c("UnreconciledDialog", {
        ref: "unreconciledDialog",
        on: { refresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c("StatementPaymentDialog", {
        ref: "statementPaymentDialog",
        on: { refresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c("RejectStatementDialog", {
        ref: "rejectStatementDialog",
        on: { refresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c("UpdateStatementDialog", {
        ref: "updateStatementDialog",
        on: { refresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.remarkPopover.visible,
            title: _vm.remarkPopover.title,
            width: "500px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.remarkPopover, "visible", $event)
            },
          },
        },
        [
          _c("div", { staticClass: "remark-popover-content" }, [
            _vm._v(_vm._s(_vm.remarkPopover.content)),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }